export default "__VITE_ASSET__53609546__"